import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import { ArrowUpRight, BookOpen } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function JournalTeaser() {
  const [articles, setArticles] = useState([]);
  useEffect(() => {
    axios.get(`${API}/articles`).then((r) => setArticles(r.data.slice(0, 3))).catch(() => {});
  }, []);

  if (articles.length === 0) return null;

  return (
    <section id="journal" className="py-20 md:py-32 bg-white" data-testid="journal-teaser">
      <div className="max-w-[1440px] mx-auto px-5 md:px-12">
        <div className="grid grid-cols-12 gap-4 md:gap-6 mb-10 md:mb-12 items-end">
          <div className="col-span-12 md:col-span-8">
            <div className="eyebrow mb-4">The Journal</div>
            <h2 className="font-display text-3xl md:text-5xl leading-tight tracking-[-0.02em]">
              Honest writing on <br /><span className="text-[hsl(var(--primary))]">dental care.</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-4 md:text-right">
            <Link to="/blog" className="btn-pill btn-outline inline-flex" data-testid="journal-see-all">
              Read the journal <span className="arrow"><ArrowUpRight size={16}/></span>
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {articles.map((a, i) => (
            <motion.div
              key={a.slug}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
            >
              <Link to={`/blog/${a.slug}`} className="card-soft block overflow-hidden group" data-testid={`journal-card-${a.slug}`}>
                <div className="aspect-[16/11] overflow-hidden bg-[hsl(var(--bg-2))]">
                  <img src={a.cover} alt={a.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 text-[12px] text-[hsl(var(--ink-soft))]">
                    <BookOpen size={13} /> {a.reading_time_min} min read
                  </div>
                  <div className="font-display text-lg md:text-xl leading-tight mt-3">{a.title}</div>
                  <p className="mt-3 text-[13px] text-[hsl(var(--ink-soft))] line-clamp-2 leading-relaxed">{a.excerpt}</p>
                  <div className="mt-5 text-[13px] font-medium text-[hsl(var(--primary-dark))] inline-flex items-center gap-2">Read article <ArrowUpRight size={14} /></div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
